import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinouterring() {



  const cardData =
  {
    keyword: ' Corporate Cab Services in Outer Ring Road (ORR) Corridor Bangalore',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Services in Outer Ring Road (ORR) Corridor Bangalore',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and reliable Corporate Cab Services in the Outer Ring Road (ORR) Corridor Bangalore, catering to the transportation needs of IT parks, corporate offices, and business hubs along this major business corridor. Our fleet of executive sedans, SUVs, and premium vehicles ensures safe, comfortable, and punctual travel for employees, clients, and senior executives. Whether it is daily office commute, airport transfers, inter-office travel, business meetings, or VIP transportation, we deliver seamless and hassle-free mobility solutions. With trained chauffeurs, flexible rental plans, and well-maintained vehicles, Pune Corporate Cars India Private Limited ensures a premium and dependable corporate travel experience for businesses operating in and around the ORR Corridor Bangalore.',

    top: 'Top Places to Visit in Bangalore with Pune Corporate Car',

"topPlaces": [
  {
    "title": "Bangalore Palace",
    "description": "Bangalore Palace, built in the 19th century, is inspired by England’s Windsor Castle and showcases Tudor-style architecture with fortified towers, elegant woodwork, and sprawling gardens. Visitors can explore the royal interiors, vintage furniture, and photo galleries. The palace also hosts cultural events, music concerts, and exhibitions, making it a hub for history and heritage enthusiasts."
  },
  {
    "title": "Lalbagh Botanical Garden",
    "description": "Lalbagh Botanical Garden spans 240 acres and is famous for its diverse flora, centuries-old trees, and iconic glasshouse. It hosts biannual flower shows attracting visitors from across the city. The garden offers walking paths, serene lakes, and picturesque landscapes, making it ideal for nature lovers, photographers, and families seeking relaxation amidst greenery."
  },
  {
    "title": "Cubbon Park",
    "description": "Cubbon Park is a 300-acre urban oasis in central Bangalore featuring lush greenery, walking trails, jogging paths, and playgrounds. It houses statues, government buildings, and botanical features, creating a perfect blend of nature and culture. The park is a popular spot for morning walks, family outings, photography, and leisurely strolls."
  },
  {
    "title": "Vidhana Soudha",
    "description": "Vidhana Soudha is an iconic government building in Bangalore known for its Neo-Dravidian architectural style. It features grand pillars, intricate stone carvings, and massive domes. Though entry is restricted, the majestic facade and surrounding viewpoints provide excellent photo opportunities, and it stands as a symbol of Karnataka’s political and cultural heritage."
  },
  {
    "title": "ISKCON Temple Bangalore",
    "description": "The ISKCON Temple in Bangalore is a spiritual and cultural center dedicated to Lord Krishna. The temple features traditional architecture, vibrant murals, and beautifully landscaped gardens. Visitors can participate in devotional ceremonies, cultural programs, and enjoy vegetarian meals at the temple’s food court, making it a peaceful escape for meditation and spiritual learning."
  },
  {
    "title": "Commercial Street",
    "description": "Commercial Street is one of Bangalore’s busiest shopping destinations, offering clothing, footwear, jewelry, and street food. Locals and tourists flock here for shopping, bargain hunting, and exploring vibrant street markets. The lively atmosphere and colorful storefronts make it a must-visit for retail enthusiasts and urban explorers."
  },
  {
    "title": "Bannerghatta National Park",
    "description": "Bannerghatta National Park is a major wildlife destination near Bangalore, featuring a zoo, butterfly park, safari rides, and trekking trails. Visitors can see lions, tigers, elephants, and other animals in naturalistic habitats. The park is ideal for families, wildlife enthusiasts, and students seeking educational and recreational experiences close to the city."
  },
  {
    "title": "Ulsoor Lake",
    "description": "Ulsoor Lake is a scenic water body in central Bangalore, popular for boating, photography, and evening strolls. Surrounded by greenery and small islands, it provides a serene spot for relaxation, picnics, and spending quality time with family or friends amidst the city’s bustle."
  },
  {
    "title": "Nandi Hills",
    "description": "Nandi Hills, located on the outskirts of Bangalore, is a scenic hill station known for breathtaking sunrise views, trekking trails, and historical sites like Tipu Sultan’s Summer Palace. The cool climate, lush landscapes, and panoramic vistas make it a favorite spot for nature lovers, photographers, and adventure seekers looking for a refreshing escape."
  },
  {
    "title": "Wonderla Amusement Park",
    "description": "Wonderla, located near Bangalore, is a top amusement park offering thrilling rides, water slides, and family entertainment zones. It is ideal for a fun-filled day with friends and family, featuring safe rides, adventure zones, and well-maintained facilities. Seasonal events and themed attractions make it a popular destination for both locals and tourists seeking excitement and leisure."
  }
],


"services": [
{
"name": "ORR Office Cab",
"description": "ORR Office Cab provides a fully managed corporate commuting solution for employees and executives working along the Outer Ring Road (ORR) in Bangalore. The service offers a large fleet of sedans and SUVs, trained chauffeurs, GPS-enabled tracking, and real-time scheduling to ensure punctual pick-ups and drops. Designed for IT parks, corporate campuses, and industrial offices, it supports multi-shift operations, optimized routing, and seamless office connectivity, delivering a safe, reliable, and comfortable daily commute experience for all workforce categories."
},
{
"name": "ORR Employee Shuttle",
"description": "ORR Employee Shuttle delivers high-capacity shuttle services for large teams commuting along the ORR corridor. Using air-conditioned minibuses and vans, it provides structured routes, trip clustering, real-time tracking, and attendance integration. The service is ideal for IT parks and corporate campuses with bulk employee movement, ensuring dependable, organized, and safe shuttle operations throughout the day while accommodating multiple shifts efficiently."
},
{
"name": "ORR IT Park Transport",
"description": "ORR IT Park Transport specializes in workforce mobility solutions for IT parks and business campuses along the ORR. The service provides well-planned shuttle and cab routes, centralized dispatching, real-time vehicle monitoring, and multi-shift support. It ensures timely, safe, and comfortable transportation for employees, including last-mile connectivity within IT park complexes, making daily commute hassle-free and optimized for corporate efficiency."
},
{
"name": "Corporate Fleet ORR Corridor",
"description": "Corporate Fleet ORR Corridor offers end-to-end fleet management solutions for companies requiring sedans, SUVs, and employee shuttles for daily operations. The service includes professional driver management, vehicle maintenance, compliance monitoring, GPS tracking, and scheduling support. Ideal for IT, BPO, and corporate offices along the ORR, it guarantees scalable, reliable, and cost-efficient corporate mobility while ensuring employee safety and service consistency."
},
{
"name": "Staff Pickup Drop ORR",
"description": "Staff Pickup Drop ORR provides structured daily commute services for employees traveling to and from offices along the ORR. With fixed, flexible, and rotating routes, professional chauffeurs, GPS tracking, and real-time updates, it ensures punctual pick-ups and drops. The service is designed to handle multiple shifts, optimize route efficiency, and deliver a safe and comfortable travel experience for all employees."
},
{
"name": "Affordable ORR Cab",
"description": "Affordable ORR Cab delivers cost-effective corporate transportation solutions without compromising on safety, comfort, or reliability. The service caters to startups, SMEs, and mid-size companies along the ORR corridor, offering clean sedans, SUVs, and shuttle vehicles with trained drivers. Efficient route planning, real-time tracking, and prompt pick-ups ensure smooth and budget-friendly employee mobility for daily commutes and office travel."
},
{
"name": "Best Corporate Cabs ORR",
"description": "Best Corporate Cabs ORR offers premium corporate transportation with top-quality vehicles, verified and professional chauffeurs, and high service standards. Designed for executives, managers, and business visitors, it ensures timely, safe, and comfortable travel along the ORR corridor. The service provides GPS tracking, multi-shift support, and scalable fleet options to meet the daily commute and business travel needs of corporate organizations."
},
{
"name": "Business Cab ORR Bangalore",
"description": "Business Cab ORR Bangalore provides dedicated executive travel solutions including inter-office transfers, client visits, airport trips, and business meetings along the ORR corridor. The service includes luxury sedans, SUVs, trained chauffeurs, quick dispatching, and real-time GPS tracking, ensuring punctual, professional, and comfortable travel experiences for business professionals and corporate clients."
},
{
"name": "Monthly Cab ORR",
"description": "Monthly Cab ORR offers long-term cab services for companies requiring consistent employee transportation. The service provides dedicated vehicles, professional drivers, maintenance coverage, GPS-enabled tracking, and flexible monthly packages. It ensures uninterrupted commute for employees and executives, with predictable costs, reliability, and convenience for multi-shift operations along the ORR corridor."
},
{
"name": "Sedan Cab ORR",
"description": "Sedan Cab ORR provides executive-class sedans suitable for managers, senior staff, airport transfers, client meetings, and premium daily commutes. Each vehicle is well-maintained, equipped with modern amenities, and driven by professional chauffeurs, delivering a comfortable, punctual, and safe travel experience for employees along the ORR corridor."
},
{
"name": "SUV Cab ORR",
"description": "SUV Cab ORR offers spacious and high-comfort SUVs for team travel, outstation trips, VIP transfers, and executive commuting along the ORR corridor. With trained chauffeurs, real-time tracking, and advanced safety features, the service ensures reliable, safe, and comfortable mobility for corporate employees and senior management."
},
{
"name": "Employee Transportation ORR",
"description": "Employee Transportation ORR provides large-scale workforce mobility solutions for companies along the ORR. The service integrates route optimization, multi-shift planning, GPS-enabled vehicle tracking, safety protocols, and real-time monitoring. It ensures timely, secure, and organized employee transport across multiple locations, catering to IT parks, corporate campuses, and industrial hubs efficiently."
},
{
"name": "Office Commute ORR",
"description": "Office Commute ORR delivers structured and reliable employee commute services with pre-planned routes, trained drivers, and real-time trip monitoring. Designed for corporate offices along the ORR, the service supports flexible and fixed shift operations, seamless last-mile connectivity, punctual pick-ups, and optimized travel schedules to ensure comfortable and safe daily office travel for employees."
},
{
"name": "Corporate Shuttle ORR Road",
"description": "Corporate Shuttle ORR Road provides high-capacity shuttle services along ORR Road for large teams and corporate campuses. Using AC minibuses and vans, the service offers multiple route planning, efficient trip clustering, driver management, GPS tracking, and multi-shift support. It ensures safe, dependable, and organized transportation for employees throughout the day, streamlining large-scale staff mobility operations."
},
{
"name": "Outstation Cab ORR",
"description": "Outstation Cab ORR provides long-distance corporate travel services for intercity meetings, factory visits, client trips, and executive travel from ORR locations. Featuring sedans and SUVs, experienced chauffeurs, interstate permits, and GPS tracking, the service ensures a safe, comfortable, and professional travel experience for corporate clients traveling beyond the ORR corridor."
}
],

"tableData": [
["ORR Office Cab", "ORR Employee Shuttle"],
["ORR IT Park Transport", "Corporate Fleet ORR Corridor"],
["Staff Pickup Drop ORR", "Affordable ORR Cab"],
["Best Corporate Cabs ORR", "Business Cab ORR Bangalore"],
["Monthly Cab ORR", "Sedan Cab ORR"],
["SUV Cab ORR", "Employee Transportation ORR"],
["Office Commute ORR", "Corporate Shuttle ORR Road"],
["Outstation Cab ORR", ""]
],


  





"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Services in Outer Ring Road (ORR) Corridor Bangalore",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides reliable corporate cab services along the Outer Ring Road (ORR) Corridor in Bangalore, ensuring smooth and efficient transportation for employees and business executives."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drop-offs",
    "WhyChoosedescription": "We ensure punctual pickups and drop-offs across ORR Corridor offices, IT parks, and commercial hubs, helping professionals reach their destinations on time."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained chauffeurs provide safe, courteous, and disciplined travel, ensuring comfortable and secure commuting for corporate clients."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all sanitized, serviced, and maintained for safe and comfortable corporate travel."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Packages",
    "WhyChoosedescription": "We offer flexible cab rental plans tailored to meet the commuting needs of businesses and employees along the ORR Corridor in Bangalore."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Support",
    "WhyChoosedescription": "Our team provides round-the-clock assistance for bookings, emergencies, and route adjustments, ensuring uninterrupted corporate travel."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are regularly sanitized and equipped with modern safety features, offering secure and comfortable rides for employees and executives."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Corporate travel is managed effortlessly through our streamlined booking process and reliable coordination, making employee transport hassle-free."
  }
]

































  }

const faqData = [
  {
    question: 'Do you provide corporate cab services along the Outer Ring Road (ORR) Corridor in Bangalore?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers dedicated and reliable corporate cab services across the Outer Ring Road (ORR) Corridor, covering major tech parks and corporate hubs.',
  },
  {
    question: 'Which areas along the ORR Corridor do you cover?',
    answer: 'We cover Marathahalli, Bellandur, Sarjapur Road, Kadubeesanahalli, Mahadevapura, HSR Layout, KR Puram, and all major ORR tech parks.',
  },
  {
    question: 'Do you offer daily employee commute services along ORR?',
    answer: 'Yes, we provide structured daily commute services with optimized routing, punctual pickups, and multi-shift transportation for employees.',
  },
  {
    question: 'How can companies book corporate cab services along the ORR Corridor?',
    answer: 'Companies can book easily through our website, mobile app, or via our 24×7 corporate transportation support team.',
  },
  {
    question: 'What vehicle options do you offer for ORR corporate cab services?',
    answer: 'We offer hatchbacks, sedans, SUVs, luxury cars, Innova Crysta, and tempo travellers depending on corporate travel needs.',
  },
  {
    question: 'Do you provide long-term transportation contracts for ORR-based companies?',
    answer: 'Yes, we offer monthly, quarterly, and annual transportation contracts tailored for companies along the ORR Corridor.',
  },
  {
    question: 'Are your cabs equipped with safety and monitoring systems?',
    answer: 'All our vehicles are GPS-enabled, sanitized, and driven by trained and background-verified chauffeurs to ensure employee safety.',
  },
  {
    question: 'Do you support night shift and rotational shift cab services along ORR?',
    answer: 'Absolutely. We manage transportation for early morning, late night, weekend, and rotational shifts for ORR-based employees.',
  },
  {
    question: 'What payment options are available for corporate cab services?',
    answer: 'We accept UPI, bank transfers, corporate invoicing, credit/debit cards, and digital wallet payments.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Nishant Kulkarni',
    feedback: 'Outstanding cab service for our ORR office. On-time pickups and very well-coordinated employee transportation.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Rhea D’Souza',
    feedback: 'Reliable and professional service along the ORR Corridor. Clean cars and excellent driver behaviour every day.',
    rating: 5,
  },
];



































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Outer Ring Road (ORR) Corridor Bangalore",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cab-orr-bangalore.jpg", // replace with correct image if needed
  "description":
    "Pune Corporate Cars India Private Limited provides reliable corporate cab services in Outer Ring Road (ORR) Corridor Bangalore, including employee shuttles, IT park transport, office pickup & drop, corporate fleet solutions, business cabs, monthly cab services, outstation trips, and executive chauffeur-driven vehicles for companies operating along the ORR corridor.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-services-orr-corridor-bangalore"
  }
};




  return (
    <div>

<Helmet>
  <title>Corporate Cab Services in ORR Corridor Bangalore | Employee & Business Transport</title>

  <meta
    name="description"
    content="Professional corporate cab services in Outer Ring Road (ORR) Corridor Bangalore including employee shuttles, IT park transport, staff pickup & drop, business cabs, monthly cab services, outstation trips, and corporate fleet solutions."
  />

  <meta
    name="keywords"
    content="ORR Office Cab, ORR Employee Shuttle, ORR IT Park Transport, Corporate Fleet ORR Corridor, Staff Pickup Drop ORR, Affordable ORR Cab, Best Corporate Cabs ORR, Business Cab ORR Bangalore, Monthly Cab ORR, Sedan Cab ORR, SUV Cab ORR, Employee Transportation ORR, Office Commute ORR, Corporate Shuttle ORR Road, Outstation Cab ORR"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/64.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinouterring;